/**
 * 可视化 选择商品、专题 table列表配置项
 */
export const config = {
    entities: {
        DesignProductSelector: {
            apiPath: '/product',
            properties: {
                id: {
                    type: 'string',
                    format: 'title',
                },
                name: {
                    type: 'string',
                    displayName: '商品名称',
                },
                goodsMvo: {
                    type: 'object',
                    properties: {
                        spuCode: {
                            type: 'string',
                            displayName: '编号',
                        },
                    },
                },

                barcode: {
                    type: 'string',
                    displayName: '商品二维码',
                },
            },
            filters: {
                name: {
                    type: 'string',
                    format: 'trimString',
                    displayName: '关键字',
                },
            },
        },

        DesignTopicSelector: {
            apiPath: '/page?type=topic',
            properties: {
                id: {
                    type: 'string',
                    displayName: 'ID',
                },
                name: {
                    type: 'string',
                    displayName: '名称',
                },
                type: {
                    type: 'string',
                    displayName: '类型',
                },
                createTime: {
                    type: 'string',
                    displayName: '创建时间',
                },
            },
            filters: {
                name: {
                    type: 'string',
                    displayName: '关键字',
                },
            },
        },
    },
};
